import { render, staticRenderFns } from "./CreateSpendPointTransaction.vue?vue&type=template&id=3da6d948&scoped=true"
import script from "./CreateSpendPointTransaction.vue?vue&type=script&lang=js"
export * from "./CreateSpendPointTransaction.vue?vue&type=script&lang=js"
import style0 from "./CreateSpendPointTransaction.vue?vue&type=style&index=0&id=3da6d948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6d948",
  null
  
)

export default component.exports